// 스트리머 사용자를 위한 스토어

import {create} from "zustand";
import {Account, Schedule, Viewer} from "../contexts";

const useUserActionStore = create((set) => ({
  userAction: null,
  setUserAction: (userAction: ActionState) => set({ userAction }),
  closeUserAction: () => set((state:ActionState) => ({userAction: { isActive: false, props: state!.props }})),
  handleUserAction: (props: Action) => set({ userAction: { isActive: true, props }}),
}));


interface ActionState {
  isActive: boolean
  props: Action
}

interface Action {
  viewer: Viewer
  account: Account
  schedule: Schedule | null
}

export {
  useUserActionStore,
}


